import React from "react";
import "./styles.css";
import { Typography, Grid } from "@mui/material";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import StarRating from "../../components/Feedback-Star";

export default function PlumberCard({ data, showTitle, profile }) {
  const navigate = useNavigate();

  return (
    <Grid className="plumber-card">
      <Grid className="plumberbox-matchingJobs-card">
        <Grid className="card-img-section">
          <Grid>
            <img className="card-img" src="https://picsum.photos/100" alt="" />
          </Grid>
          <Typography
            id="two-lines-text-css"
            maxWidth="80%"
            textAlign="center"
            style={{
              marginTop: "7px",
              fontSize: "12px",
              fontWeight: "bold",
              lineHeight: "1.2",
            }}
          >
            Name
          </Typography>
          <Typography
            textAlign="center"
            style={{
              fontSize: "12px",
              color: "#676767",
            }}
            id="two-lines-text-css"
          >
            {" "}
            Location name
          </Typography>
          <Typography
            style={{
              fontSize: "12px",
            }}
          >
            2.8 Km
          </Typography>
        </Grid>
        <Grid width="70%" position="relative" pl={1} pt={2} pr={2} pb={2}>
        <Grid style={{display:'flex', alignItems:'center'}}>
            <Typography color="rgba(114, 114, 114, 1)" style={{fontSize: "12px",paddingRight:'5px' }}>
            Rating :
            <span style={{ fontWeight: "bold", color: "black",paddingLeft:'5px'}}>
              4.3
            </span>
          </Typography>
          <Grid style={{paddingBottom:'2px', paddingLeft:'px'}}>
          <StarRating size={18} value={1} count={1} edit={false} />
          </Grid>
          </Grid>

          <Grid
            mb={0.5}
            mt={0.5}
            display="flex"
            // border="1px solid red"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              fontWeight="bold"
              style={{
                fontSize: "12px",
              }}
            >
              <span
                style={{
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "#0d4f57",
                }}
              >
                Job Done :{" "}
              </span>
              28
            </Typography>{" "}
          </Grid>
          <Typography
            id="two-lines-text-css"
            color="rgba(114, 114, 114, 1)"
            // mb={1}
            style={{
              fontSize: "12px",
              lineHeight: "1.2",
            }}
          >
            Skills :{" "}
            <span style={{ color: "black" }}>
              Water Tank leakage Water Tank and Motor repair
            </span>
          </Typography>
          {profile ? (
            <>
              {" "}
              <Grid mt={1.5}>
                <Button
                  name="View Profile"
                  color="green"
                  onClick={() => {
                    // navigate("/jobDetails");
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              {" "}
              <Grid mt={1.5}>
                <Button
                  color="green"
                  name="View Details"
                  onClick={() => {
                    navigate("/jobDetails");
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
